import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import packageInfo from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Central de ajuda - Dinamize';

  constructor(
    private titleService: Title,
    private metaService: Meta,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'dinamize-help:version', content: packageInfo.version },
      { name: 'robots', content: 'index, follow' },
    ]);
  }
}
